import { DataHandlerDevice, Device } from "luxedo-data"
import { getSubscriptionManager } from "./SubscriptionManager.svelte"
import { DeviceApi } from "@devices/api-client"

export const deviceApi = new DeviceApi(`${import.meta.env.VITE_API_URL}/api`)

/**
 * Links the specified device to the user's active LuxPlay subscription and returns true, unless the user has no active LuxPlay subscription with an unused device slot in which case false is returned
 * @param dev
 * @returns
 */
export async function linkDeviceToSubscription(dev: Device): Promise<boolean> {
	const subManager = getSubscriptionManager()
	const availableSubscription = subManager.subscriptions.find(
		(sub) => sub.type === "LUX_PLAY_ANNUAL" && sub.availableUnits > 0,
	)

	if (availableSubscription) {
		await deviceApi.linkDeviceToSubscription(dev.id, availableSubscription.id)
		return true
	} else return false
}

/**
 * Links as many un-linked LuxPlay devices as available
 */
export async function autoLinkLuxPlayDevice(subscriptionId: string) {
	const allDevices = DataHandlerDevice.getMany().filter((dev) => dev.typeId == "dev_luxcast")
	// find devices which need a license and don't have one yet and apply it
	for (const dev of allDevices) {
		const status = await deviceApi.getDeviceStatus(dev.id)
		if (status.license == "LUXPLAY" && !status.subscriptionId) {
			return await deviceApi.linkDeviceToSubscription(dev.id, subscriptionId)
		}
	}
}
